import {isDefined} from 'shared/web';

import {RELATED_CUSTOM_NOTICES_TAG} from '../constants/RELATED_CUSTOM_NOTICES_TAG';

/**
 * Spread into an `invalidatesTags` list to add the related custom notices tag only when the
 * mutation succeeded.
 *
 * RTK invalidates tags for rejected mutations too, and `teasBaseQuery` turns an API error into a
 * rejection with value, so an unconditional tag would refetch every subscribed notices query
 * after a failed request that changed no relation. Use this instead of wrapping the whole
 * callback in `invalidateOnSuccess` when the endpoint's other tags are expected to keep
 * invalidating regardless of the outcome.
 */
export const relatedCustomNoticesTagsOnSuccess = (error: unknown) =>
  isDefined(error) ? [] : [RELATED_CUSTOM_NOTICES_TAG];
